module.exports = __webpack_public_path__ + "img/logo@2.2bd6dd9c.png";